import { useFormatter } from '@api/useFormatter'
import { Texto } from '@gravitate-js/excalibrr'
import React from 'react'

export function SingleError({ error, isBypassed }) {
  const { formatVolume } = useFormatter()
  const formattedUnit = formatVolume(null, true)
  const formattedError = error.text.replace(/unit/g, formattedUnit)
  return (
    <div className='flex items-center mx-4 mt-2'>
      <div className='flex-1'>
        <div>
          <Texto weight='bold' appearance={!isBypassed && 'error'}>
            {error.type}
          </Texto>
          <Texto appearance={!isBypassed && 'error'}>
            {formattedError && formattedError.split('/n').map((a, i) => <div key={i}>{a}</div>)}
          </Texto>
        </div>
      </div>
    </div>
  )
}
